export default __webpack_public_path__ + "static/media/imagen_juego.54b8629d.png";